import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { AppFreeAnswerParameters } from 'altru-types';

@Module({ namespaced: true })
export default class StatusModule extends VuexModule {
  isInIframe = false;
  iframeParent: AppFreeAnswerParameters['source'] | null = null;
  iframeIsAdmin = false;
  originalUrlValue = '';
  initialRedirectDoneValue = false;

  get isIframed(): boolean {
    return this.isInIframe;
  }

  get iframeSource(): AppFreeAnswerParameters['source'] | null {
    return this.iframeParent;
  }

  /* 'admin' is the default value that "source" takes when opening recorder embed on the admin app when no other value for "source" is present.
   * 'app-free-admin-login' is the value that "source" takes when recorder redirects to admin */
  get iframeParentIsAdminApp(): boolean {
    if (this.iframeParent) {
      const allowedValues: AppFreeAnswerParameters['source'][] = ['admin', 'app-free-admin-login'];
      return allowedValues.includes(this.iframeParent);
    }
    return false;
  }

  get originalUrl(): string {
    return this.originalUrlValue;
  }

  get initialRedirectDone(): boolean {
    return this.initialRedirectDoneValue;
  }

  @Mutation
  setIsInIframe(value: boolean): void {
    this.isInIframe = value;
  }

  @Mutation
  setIframeSource(value: AppFreeAnswerParameters['source']): void {
    this.iframeParent = value;
  }

  @Mutation
  storeOriginalUrl(value: string): void {
    this.originalUrlValue = value;
  }

  @Mutation
  setInitialRedirectDone(value: boolean): void {
    this.initialRedirectDoneValue = value;
  }
}
